import React from 'react';
import { publicUrl } from '../utils/publicUrl';

export default function SectionTitle({ title, icon, ...rest }) {
  return (
    <div className="sectiontitle" {...rest}>
      <hr />
      <h2>{title}</h2>
      {icon ? <img src={publicUrl(icon)} alt="" className="sectiontitle__icon" /> : null}
      <hr />
    </div>
  );
}
